module.exports = __webpack_public_path__ + "img/werbas_ksr_logo.88b22ebe.svg";